export default __webpack_public_path__ + "static/media/351.22ebebb6.jpg";